import { defaultArtboardSets, getArtboardPresets, systemLog, saveArtboardPresets } from "../storage.js";
import { makeExternalLog } from "../systemLog.js";
import { default_cost } from "../../recommender/loss/evaluate.js";

export let SettingMenuPreference = {
  name: 'preference',
  title: 'Preference',
  shortcut: '.'
}
export const veryDefaultArtboards = [
  { name: "Desktop-Landscape", type: "desktop", orient: "landscape", artboard_width: 800, artboard_height: 400, icon: "laptop" }, // model: macbook pro 13"; standard ppi;
  { name: "Phone-Portrait", type: "phone", orient: "portrait", artboard_width: 390, artboard_height: 400, icon: "phone" },
  { name: "Tablet-Portrait", type: "tablet", orient: "portrait", artboard_width: 600, artboard_height: 350, icon: "tablet" },
];

export function getDefaultArtboardPresets() {
  let presets = getArtboardPresets();
  return presets || veryDefaultArtboards;
}

export function updateDefaultArtboards(action, i, d) {
  defaultArtboardSets.update((presets) => {
    let updated = false;
    if (action === "add") {
      presets.push(d);
      updated = true;
    } else if (action === "remove") {
      presets.splice(i, 1);
      updated = true;
    } else if (action === "modify") {
      presets[i] = d;
      updated = true;
    }
    if (updated) {
      makeExternalLog(systemLog, { message: action + " default artboard for " + d.name })
      saveArtboardPresets(presets);
    }
    return presets;
  })
}

export const prefDefaults = {
  withPPI: true,
  showRuler: true,
  unlockNew: true,
  responsiveDir: "large",
  nRecommendations: 7,
  nMoreLikeThis: 5,
  pDrastic: 0.6,
  lossWeight: default_cost,
  rationaleLevel: 2,
};

export const PrefKeys = {
  withPPI: "withPPI",
  showRuler: "showRuler",
  unlockNew: "unlockNew",
  responsiveDir: "responsiveDir",
  nRecommendations: "nRecommendations",
  nMoreLikeThis: "nMoreLikeThis",
  pDrastic: "pDrastic",
  lossWeight: "lossWeight",
  rationaleLevel: "rationaleLevel"
};

export const ResponsiveDirections = ["large", "small"];